import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { type BuyerIncentiveName } from './hooks/useBuyerIncentivesList.ts';

const BuyerIncentiveCopy: FC<{
    name: BuyerIncentiveName;
}> = ({ name }) => {
    switch (name) {
        case 'authenticityGuarantee':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.authenticityGuarantee"
                    defaultMessage="Authenticity Guaranteed"
                />
            );

        case 'moneyBackGuarantee':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.moneyBackGuarantee"
                    defaultMessage="Money Back Guarantee"
                />
            );
        case 'cancelationPolicy':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.cancelationPolicy"
                    defaultMessage="24-Hour Cancellation"
                />
            );
        case 'vettedSellers':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.vettedSellers"
                    defaultMessage="Sellers We Know and Trust"
                />
            );
        case 'priceMatch':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.priceMatch"
                    defaultMessage="Price Matching"
                />
            );
        case 'globalDelivery':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.globalDelivery"
                    defaultMessage="Protected Global Delivery"
                />
            );
        case 'returnPolicy':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.returnPolicy"
                    defaultMessage="Industry-Leading Return Policy"
                />
            );
        default:
            return null;
    }
};

export default BuyerIncentiveCopy;
